import type { FRENCH_LOCALE } from "~ui/@application/locales/fr.ts";

import { AUTHENTICATION_ENGLISH_LOCALE } from "~ui/@application/locales/modules/authentication/authentication.en.ts";
import { COMMON_ENGLISH_LOCALE } from "~ui/@application/locales/modules/common/common.en.ts";
import { COMPONENTS_ENGLISH_LOCALE } from "~ui/@application/locales/modules/components/components.en.ts";

export const ENGLISH_LOCALE = {
  common: COMMON_ENGLISH_LOCALE,
  components: COMPONENTS_ENGLISH_LOCALE,
  authentication: AUTHENTICATION_ENGLISH_LOCALE,
} satisfies typeof FRENCH_LOCALE;

export default ENGLISH_LOCALE;
